import { S } from './ModalContent.styles';
import type { ModalContentProps } from './ModalContent.types';

export const ModalContent = (props: ModalContentProps) => <S.Content {...props} />;
